import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

export async function getFacebookIntegrations(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<any> {
  const response = await client.client.get("support/facebook", {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}

export async function toggleFacebookComment(
  client: RedoMerchantClient,
  {
    conversationId,
    commentId,
    messageId,
    hide = true,
  }: {
    conversationId: string;
    commentId: string;
    messageId?: string;
    hide?: boolean;
  },
): Promise<{ success: boolean }> {
  try {
    const response = await client.client.post(
      "support/facebook/toggle-comment",
      { conversationId, commentId, messageId, hide },
      { headers: client.authorization() },
    );
    return response.data;
  } catch (error) {
    const action = hide ? "hide" : "unhide";
    console.error(`Failed to ${action} Facebook comment:`, error);
    return { success: false };
  }
}

export async function deleteMetaComment(
  client: RedoMerchantClient,
  {
    conversationId,
    commentId,
    platform = "facebook",
  }: {
    conversationId: string;
    commentId: string;
    platform?: "facebook" | "instagram";
  },
): Promise<{ success: boolean }> {
  try {
    const response = await client.client.post(
      `support/${platform}/delete-comment`,
      { conversationId, commentId },
      { headers: client.authorization() },
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to delete ${platform} comment:`, error);
    return { success: false };
  }
}

export async function unlikeMetaComment(
  client: RedoMerchantClient,
  {
    conversationId,
    commentId,
    platform = "facebook",
  }: {
    conversationId: string;
    commentId: string;
    platform?: "facebook" | "instagram";
  },
): Promise<{ success: boolean }> {
  try {
    const response = await client.client.post(
      `support/${platform}/unlike-comment`,
      { conversationId, commentId },
      { headers: client.authorization() },
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to unlike ${platform} comment:`, error);
    return { success: false };
  }
}

export async function likeMetaComment(
  client: RedoMerchantClient,
  {
    conversationId,
    commentId,
    platform = "facebook",
  }: {
    conversationId: string;
    commentId: string;
    platform?: "facebook" | "instagram";
  },
): Promise<{ success: boolean }> {
  try {
    const response = await client.client.post(
      `support/${platform}/like-comment`,
      { conversationId, commentId },
      { headers: client.authorization() },
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to like ${platform} comment:`, error);
    return { success: false };
  }
}

export async function updateMetaComment(
  client: RedoMerchantClient,
  {
    conversationId,
    commentId,
    message,
    platform = "facebook",
  }: {
    conversationId: string;
    commentId: string;
    message: string;
    platform?: "facebook" | "instagram";
  },
): Promise<{ success: boolean }> {
  try {
    const response = await client.client.post(
      "support/meta/update-comment",
      { conversationId, commentId, message, platform },
      { headers: client.authorization() },
    );
    return response.data;
  } catch (error) {
    console.error(`Failed to update ${platform} comment:`, error);
    return { success: false };
  }
}
